import { Questions } from "@/pages/forms/components";
import { Button, GlobalStyles } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import { useSearchDataForFormPreview } from "../../hooks/useSearchDataForFormPreview";
import { ErrorModal, MesfModal } from "@dexteel/mesf-core";
import { LazyLoading } from "@/components/loaders/Loader/LazyLoading";
import { useFormsContext } from "../../context/FormsContext";

type Props = {
	show: boolean;
	onHide: (onHide: boolean) => void;
	FormId: number;
};

export const FormPreviewer = ({ show, onHide, FormId }: Props) => {
	const [dataForPreviewIsLoading, setDataForPreviewIsLoading] = useState(false);
	const [dataForPreviewError, setDataForPreviewError] = useState("");

	const searchFormsSections = useSearchDataForFormPreview({
		setDataForPreviewIsLoading,
		setDataForPreviewError,
		FormId,
	});

	const {
		state: { formInstanceSections, formInstanceQuestions, formsList },
	} = useFormsContext();

	const handleCancel = () => {
		onHide(false);
	};

	useEffect(() => {
		if (FormId) searchFormsSections();
	}, [FormId]);

	return (
		<>
			<GlobalStyles
				styles={{
					".MuiDialog-paper[aria-labelledby='form-preview-modal']": {
						width: "100%",
					},
				}}
			/>
			<MesfModal
				title={`PREVIEW - ${formsList.find((f) => f.FormId === FormId)?.FormName ?? ""}`}
				open={show}
				handleClose={handleCancel}
				maxWidth="xl"
				id="form-preview-modal"
			>
				<MesfModal.Content
					dividers
					style={{ maxHeight: "75vh", overflowY: "auto" }}
				>
					<Grid2 container>
						{dataForPreviewIsLoading ? (
							<Grid2
								container
								style={{
									justifyContent: "center",
									alignItems: "center",
									height: "40vh",
								}}
								size={{ md: 12, xs: 12 }}
							>
								<LazyLoading />
							</Grid2>
						) : (
							<Grid2 size={{ md: 12, xs: 12 }}>
								<Questions
									formInstanceSections={formInstanceSections}
									formInstanceQuestions={formInstanceQuestions}
									layoutCode={"T"}
								/>
							</Grid2>
						)}
						<ErrorModal
							error={dataForPreviewError}
							onHide={() => setDataForPreviewError("")}
						/>
					</Grid2>
				</MesfModal.Content>
				<MesfModal.Actions style={{ padding: "20px 16px 16px" }}>
					<Grid2 container spacing={2} justifyContent="flex-end" width="100%">
						<Grid2 size={{ md: 3, xs: 12 }}>
							<Button
								fullWidth
								variant="contained"
								color="inherit"
								onClick={handleCancel}
							>
								Close
							</Button>
						</Grid2>
					</Grid2>
				</MesfModal.Actions>
			</MesfModal>
		</>
	);
};
